module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box11",
    staticStyle: {
      "width": "100%",
      "height": "55px",
      "display": "flex",
      "align-items": "flex-start",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "box_left"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "src": require("../assets/images/48.png")
    },
    on: {
      "click": _vm.left
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "transition": "1s"
    },
    style: ({
      marginLeft: -_vm.lefttt + 'px'
    })
  }, _vm._l((_vm.arealist), function(item, eindex) {
    return _c('div', {
      staticClass: "box1_cent",
      on: {
        "click": function($event) {
          return _vm.indexchange(eindex)
        }
      }
    }, [_c('div', {
      staticClass: "box1_cent_tt1",
      class: eindex == _vm.index ? 'sty' : ''
    }), _vm._v(" "), _c('div', {
      staticClass: "box1_cent_tt text-cut1",
      style: (eindex == _vm.index ? 'color: #0066d9;' : '')
    }, [_vm._v(" " + _vm._s(item))])])
  }), 0)]), _vm._v(" "), _c('img', {
    staticClass: "img1",
    staticStyle: {
      "transform": "rotate(180deg)"
    },
    attrs: {
      "src": require("../assets/images/48.png")
    },
    on: {
      "click": _vm.next
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02241b3b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timechang.vue
// module id = 1078
// module chunks = 1